const intervalId = setInterval(() => {
  if (typeof wofConfig != 'undefined' && wofConfig.settings && wofConfig.tableRowStructure) {
    clearInterval(intervalId);
    modifyWof();
  }
}, 10);

function modifyWof() {
  var newColumn = '{ "name": "Technical Size", "value": true, "uniqName": "technical_size_detailed" }';
  wofConfig.settings.table_columns.push(JSON.parse(newColumn));
  wofConfig.tableRowStructure = wofConfig.tableRowStructure.replace('<td>quantityBoxHtml</td>', '<td class="technical_size_detailed"></td><td>quantityBoxHtml</td>');

  document.body.addEventListener('click', function(event) {
    if (event.target.className.includes('wof-show-variant') || event.target.closest('.wof-show-variant')) {
      addVariantData(event.target);
    }
  })
}

function addVariantData(product) {
  console.log('Adding variant metafield data!');
  if (product.className.includes('wof-show-variant') == false) {
    product = product.closest('.wof-show-variant');
  }
  
  var variantData = product.closest('tr.product-row').querySelector('.wof-product-title script').textContent;
  variantData = variantData.replace(/["']/g, '"');
  variantData = JSON.parse(variantData);
  
  var productId = product.getAttribute('data-product-id');
  const variantSearch = setInterval(() => {
    if (document.querySelector(`.variant-row.product-${productId}`)) {
      clearInterval(variantSearch);
      var variantRows = document.querySelectorAll(`.variant-row.product-${productId}`);
      variantData.forEach((entry) => {
        document.querySelector(`.variant-row.variant-${entry.id} .technical_size_detailed`).innerText = entry.metafield;
      })
    }
  }, 10);
}